
export const SYMBOLS: string[] = ["A", "B", "C", "D"];

export enum SwitchStateEnum {
    off_immediately = -1,
    off = 0,
    on = 1,
    disable = 2
}

export class SwitchModel {

    public state: SwitchStateEnum = SwitchStateEnum.off;
    public value: string = "";
    public index: number = 0;

    constructor(symbol:string, index: number) {

        this.value = symbol;
        this.index = index;
    }

}